import { Fragment } from 'react'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import CompanyProjectsTableRow from './company-projects-table-row'
import {
  CompanyProjectsFolderStatusRow,
  CompanyProjectsTableStatusRow
} from './company-projects-table-status-row'
import {
  NotFoundContainerBody,
  NotFoundContainerCell,
  NotFoundContainerContent,
  NotFoundContainerRow
} from '../../../../../styled-component'
import NotFoundComponent from '../../../../../../../components/stories/molecules/not-found'
import { Project } from '../../../../../../../components/stories/atoms/icons/entities'
import colorsOptions from '../../../../../../../components/stories/fundamentals/colors-styles/constants'
import ButtonComponent from '../../../../../../../components/stories/atoms/button'
import { buttonVariantOptions } from '../../../../../../../components/stories/atoms/button/constants'
import { textStyleSizeOptions } from '../../../../../../../components/stories/fundamentals/text-styles/constants'

const CompanyProjectsTableBody = ({
  canCreateProjects,
  childrenByFolderId,
  folderChildrenStateById,
  formatMessage,
  isError,
  movingItemIds = [],
  onCreateProject,
  rowSelection,
  rowsById,
  table,
  search
}) => {
  const allVisibleRows = table.getRowModel().rows
  const seenRowIds = new Set()
  const visibleRows = allVisibleRows.filter((row) => {
    if (seenRowIds.has(row.id)) return false
    seenRowIds.add(row.id)
    return true
  })
  const visibleRowIds = visibleRows.map((row) => row.id)
  const colSpan = table.getAllColumns().length

  if (isError) {
    return (
      <tbody>
        <CompanyProjectsTableStatusRow colSpan={colSpan}>
          {formatMessage({
            id: 'common_errors_list-load',
            defaultMessage: 'Unable to load projects'
          })}
        </CompanyProjectsTableStatusRow>
      </tbody>
    )
  }

  if (!visibleRows.length) {
    return (
      <NotFoundContainerBody>
        <NotFoundContainerRow>
          <NotFoundContainerCell colSpan={colSpan}>
            <NotFoundContainerContent>
              {search ? (
                <NotFoundComponent
                  header={formatMessage({ id: 'pinList_noResult' })}
                  headerSize={textStyleSizeOptions['TEXT-XXL']}
                  description={formatMessage({ id: 'not_found_description' })}
                  descriptionSize={textStyleSizeOptions['TEXT-L']}
                />
              ) : (
                <>
                  <NotFoundComponent
                    icon={
                      <Project
                        stroke={colorsOptions.greys['grey-50']}
                        style={{
                          width: '144px',
                          height: '144px'
                        }}
                      />
                    }
                    header={formatMessage({ id: 'no_org_projects' })}
                    headerSize={textStyleSizeOptions['TEXT-XXL']}
                    description={formatMessage({
                      id: 'no_org_projects_description'
                    })}
                    descriptionSize={textStyleSizeOptions['TEXT-L']}
                  />
                  {canCreateProjects && (
                    <ButtonComponent
                      variant={buttonVariantOptions.PRIMARY}
                      onClick={onCreateProject}
                    >
                      {formatMessage({ id: 'create_project' })}
                    </ButtonComponent>
                  )}
                </>
              )}
            </NotFoundContainerContent>
          </NotFoundContainerCell>
        </NotFoundContainerRow>
      </NotFoundContainerBody>
    )
  }

  const isRowSelected = (id) => !!rowSelection?.[id]

  return (
    <tbody>
      <SortableContext
        items={visibleRowIds}
        strategy={verticalListSortingStrategy}
      >
        {visibleRows.map((row) => (
          <Fragment key={row.id}>
            <CompanyProjectsTableRow
              isSelected={isRowSelected(row.id)}
              isMoving={movingItemIds.includes(String(row.id))}
              row={row}
              rowSelection={rowSelection}
              rowsById={rowsById}
            />
            <CompanyProjectsFolderStatusRow
              childrenByFolderId={childrenByFolderId}
              colSpan={colSpan}
              folderChildrenStateById={folderChildrenStateById}
              formatMessage={formatMessage}
              row={row}
            />
          </Fragment>
        ))}
      </SortableContext>
    </tbody>
  )
}

export default CompanyProjectsTableBody
